export default "__VITE_ASSET__C1sbKOr2__"